import { useMemo } from 'react'
import MaterialWidthOptionLabel from '../../components/materials/material-width-option-label'
import { AutoCompleteOption } from '../../components/custom-form-controls/auto-complete'
import { isStandardMaterialWidth } from '../material-width'

interface UseMaterialWidthOptionsParams<TItem> {
    items?: TItem[] | null
    getWidth: (item: TItem) => number
    getDocumentId: (item: TItem) => string
    getStock?: (item: TItem) => number | undefined
    /**
     * Минимально допустимая ширина.
     * Если указана, опции с меньшей шириной будут отфильтрованы.
     */
    minWidth?: number
    /**
     * Если true, оставляет только ширины стандартного ряда 160–430 мм с шагом 5.
     */
    standardOnly?: boolean
}

const defaultGetStock = () => undefined

export default function useMaterialWidthOptions<TItem>({
    items,
    getWidth,
    getDocumentId,
    getStock = defaultGetStock,
    minWidth,
    standardOnly,
}: UseMaterialWidthOptionsParams<TItem>): AutoCompleteOption[] {
    return useMemo(() => {
        if (!items || items.length === 0) {
            return []
        }

        let filteredItems = items

        if (standardOnly) {
            filteredItems = filteredItems.filter(item => isStandardMaterialWidth(getWidth(item)))
        }

        if (minWidth != null) {
            filteredItems = filteredItems.filter(item => getWidth(item) >= minWidth)
        }

        return [...filteredItems]
            .sort((a, b) => getWidth(a) - getWidth(b))
            .map(item => {
                const width = getWidth(item)
                const stock = getStock(item)

                return {
                    label: <MaterialWidthOptionLabel width={width} stock={stock} />,
                    value: width,
                    key: getDocumentId(item),
                    stock,
                }
            })
    }, [items, getWidth, getDocumentId, getStock, minWidth, standardOnly])
}
